"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Gl1ContextAdapter = void 0;
const gl_context_adapter_1 = require("./gl-context-adapter");
/**
 * @public
 * Webgl1 context adapter. Handles viewport and context loss.
 */
class Gl1ContextAdapter extends gl_context_adapter_1.GlContextAdapter {
    constructor(canvasElement, eventService, options) {
        super(canvasElement, eventService, "webgl", options);
    }
}
exports.Gl1ContextAdapter = Gl1ContextAdapter;
//# sourceMappingURL=gl1-context-adapter.js.map